/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Task_CompletedInputs */

const cs_enum_task_completed = /** @type {(inputs: Enum_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol dokončen`)
};

const en_enum_task_completed = /** @type {(inputs: Enum_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task completed`)
};

/**
* | output |
* | --- |
* | "Task completed" |
*
* @param {Enum_Task_CompletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_task_completed = /** @type {((inputs?: Enum_Task_CompletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Task_CompletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_task_completed(inputs)
	return cs_enum_task_completed(inputs)
});